/**
 * Listing MASH events.
 * https://w.amazon.com/index.php/MASH/MASH_1.4_API#MASH_Events
 */
export const APP_PAUSE = 'appPause';
